import React from 'react'
import {
  Form,
  OverlayTrigger,
  Tooltip,
  FormControlProps,
} from 'react-bootstrap'
import InputGroup from 'react-bootstrap/InputGroup'
import HoverIcon from '../Icons/HoverIcon'
import './kycStyle.css'
import './../form/FormInput/FormInput.css'

interface Props extends FormControlProps {
  toolTipText: string
  placeHolderText: string
  onChangeHandler: (value: string) => void
  value: string
  label?: string
  required?: boolean
  autoFocus?: boolean
}

const FormControlWithToolTip = ({
  toolTipText,
  placeHolderText,
  onChangeHandler,
  value,
  label,
  required,
  autoFocus = false,
  ...rest
}: Props) => {
  return (
    <div className="flexDiv">
      <InputGroup style={{ display: 'flex' }}>
        <Form.Control
          className="custom-input"
          type="text"
          placeholder={placeHolderText}
          style={{
            position: 'relative',
            flex: '1 1 auto',
            width: '1%',
            minWidth: '0',
            maxWidth: '430px',
          }}
          value={value}
          onChange={(e) => onChangeHandler(e.target.value)}
          autoFocus={autoFocus}
          {...rest}
        />
        <OverlayTrigger
          trigger={['hover', 'focus']}
          placement="right"
          overlay={
            <Tooltip className="custom-tooltip" id="tooltip-reference">
              {toolTipText}
            </Tooltip>
          }
        >
          <div>
            <HoverIcon className="pullRight" />
          </div>
        </OverlayTrigger>
      </InputGroup>
    </div>
  )
}

export default FormControlWithToolTip
